import { combineReducers } from 'redux';

import users from './users';
import oauth from './oauth';
import files from './files';
import vehicles from './vehicles';
import locations from './locations';
import services from './services';
import cells from './cells';
import bookings from './bookings';
import internals from './internals';
import businesses from './businesses';
import prescriptions from './prescriptions';
import medicaments from './medicaments';
import purchases from './purchases';
import appointments from './appointments';
import associations from './associations';
import insurances from './insurances';
import messages from './messages';
import notifications from './notifications';
import calls from './calls';
import video from './video';

export default combineReducers({
  calls: calls.reducers,
  messages: messages.reducers,
  users: users.reducers,
  oauth: oauth.reducers,
  files: files.reducers,
  vehicles: vehicles.reducers,
  locations: locations.reducers,
  services: services.reducers,
  cells: cells.reducers,
  bookings: bookings.reducers,
  internals: internals.reducers,
  businesses: businesses.reducers,
  prescriptions: prescriptions.reducers,
  medicaments: medicaments.reducers,
  appointments: appointments.reducers,
  purchases: purchases.reducers,
  associations: associations.reducers,
  insurances: insurances.reducers,
  notifications: notifications.reducers,
  video: video.reducers,
});
